// 2026년 귀속 기준 — 개정되면 이 파일의 값과 기준 연도를 함께 고친다
export const HOMETOWN_DONATION_POLICY_BASE_YEAR = 2026;

export const ANNUAL_DONATION_LIMIT = 20_000_000;

export const FULL_DEDUCTION_LIMIT = 100_000;
export const MID_DEDUCTION_LIMIT = 200_000;
export const MID_DEDUCTION_RATE_PERCENT = 44;
export const HIGH_DEDUCTION_RATE_PERCENT = 16.5;
export const DISASTER_AREA_HIGH_DEDUCTION_RATE_PERCENT = 33;

export const GIFT_VALUE_RATE_PERCENT = 30;

// 만원 단위 숫자 표기 (절삭, 쉼표) — 뒤에 '만원'·'만 원'은 호출처가 붙인다
export const formatManWon = (amount: number) =>
  Math.floor(amount / 10_000).toLocaleString('ko-KR');

export const HOMETOWN_DONATION_POLICY_SOURCE_URL = {
  POLICY_NEWS:
    'https://www.korea.kr/news/policyNewsView.do?newsId=148959271#policyNews',
} as const;
